<template>
  <div class="libPage">
    <card class="lib-tree-wrapper">
      <el-tree
        ref="folder"
        :data="treeNode"
        highlight-current
        :props="defaultProps"
        :expand-on-click-node="false"
        default-expand-all
        node-key="id"
        draggable
        @node-contextmenu="rightClick"
        @current-change="selectedChange"
        :allow-drag="allowDrag"
        :allow-drop="allowDrop"
        @node-drop="nodeDrop"
        :indent="16"
      >
        <template slot-scope="{node,data}">
          <el-tooltip :content="data.label" placement="right-end">
            <span
              style="font-size:14px;text-overflow: ellipsis;white-space: nowrap;overflow:hidden;"
            >
              <!-- <i v-if="node.expanded" class="el-icon-ali-wenjianjia"></i> -->
              <svgicon v-if="node.expanded" iconClass="wenjianjia1"></svgicon>
              <svgicon v-else iconClass="wenjianjiaguanbi1"></svgicon>
              {{data.label}}
            </span>
          </el-tooltip>
        </template>
      </el-tree>

      <div v-show="menuVisible">
        <el-menu
          id="contextMenu"
          @select="rightClickContextMenu"
          class="menu"
          active-text-color="#303133"
        >
          <el-menu-item
            index="1"
            v-if="buttonPerCheck('createFolder')"
            class="menu-item"
          >{{$t("fileLibrary.createSubfolder")}}</el-menu-item>
          <el-menu-item
            index="2"
            v-if="buttonPerCheck('editFolder')"
            :disabled="folderDisabled"
            class="menu-item"
          >{{$t("fileLibrary.editFolder")}}</el-menu-item>
          <el-menu-item
            index="3"
            v-if="buttonPerCheck('deleteFolder')"
            :disabled="folderDisabled"
            class="menu-item"
          >{{$t("fileLibrary.deleteFolder")}}</el-menu-item>
        </el-menu>
      </div>

      <addFolderDialog ref="addFolderDialog" @folderAdded="folderAdded"></addFolderDialog>
      <editFolderDialog ref="editFolderDialog" @folderEdited="folderEdited"></editFolderDialog>
    </card>
    <card class="lib-grid-wrapper">
      <div class="action-box">
        <div class="box-left">
          <cus-btn
            type="upload"
            v-if="buttonPerCheck('upload')"
            :loading="uploading"
            @click="fileUpload"
          ></cus-btn>
          <!-- <cus-btn type="addNode" @click="addFolderStart"></cus-btn> -->
          <cus-btn type="delete" v-if="buttonPerCheck('deleteFile')" @click="fileDelete"></cus-btn>
        </div>
        <div class="box-right">
          <el-input
            :placeholder="$t('fileLibrary.search.placeholder')"
            style="width:410px;"
            clearable
            v-model="search"
            @clear="handleSearch"
            @keyup.enter.native="handleSearch"
            class="input-with-select"
          >
            <el-select v-model="queryModel" slot="prepend" style="width:160px;">
              <el-option :label="$t('fileLibrary.search.m1')" value="0"></el-option>
              <el-option :label="$t('fileLibrary.search.m2')" value="1"></el-option>
            </el-select>
            <el-button slot="append" icon="el-icon-search" @click="handleSearch"></el-button>
          </el-input>
        </div>
      </div>

      <table-page
        ref="table"
        :table-data="tableData"
        :current-page="pageNum"
        :total="total"
        :change-fun="changeTablePage"
        @selectionChange="handleSelectionChange"
      >
        <template slot="tableItem">
          <el-table-column
            prop="fileName"
            :label="$t('administration.FileName')"
            align="left"
            show-overflow-tooltip
          />

          <el-table-column
            prop="fileSize"
            :label="$t('administration.FileSize')"
            align="right"
            show-overflow-tooltip
          />

          <el-table-column
            class-name="tabAction table-column-action-dropdown"
            :label="$t('formData.action')"
            align="center"
            width="100"
          >
            <template slot-scope="scope">
              <el-dropdown class="el-dropdown-link" @command="actionHandler">
                <span class="el-dropdown-link">
                  <i class="el-icon-ali-TechnicalArea"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                    v-if="buttonPerCheck('copyLink')"
                    :command="{action:'copylink',param:scope.row}"
                  >{{$t("fileLibrary.button.copyLink")}}</el-dropdown-item>
                  <el-dropdown-item
                    v-if="buttonPerCheck('download')"
                    :command="{action:'download',param:scope.row}"
                  >{{$t("fileLibrary.button.download")}}</el-dropdown-item>
                  <!-- <el-dropdown-item :command="{action:'rename',param:scope.row}">rename</el-dropdown-item> -->
                  <el-dropdown-item
                    v-if="buttonPerCheck('deleteFile')"
                    :command="{action:'delete',param:scope.row}"
                    divided
                  >{{$t("fileLibrary.button.deleteFile")}}</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </template>
      </table-page>

      <!-- <el-dialog title="添加子目录" :visible.sync="dialogVisible" width="30%">
        <el-form ref="form" :model="form" label-position="top" hide-required-asterisk>
          <el-form-item label="文件夹" required>
            <el-input v-model="form.name"></el-input>
          </el-form-item>
          <el-form-item label="描述">
            <el-input type="textarea" :rows="2" placeholder="请输入内容" v-model="form.description"></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取消</el-button>
          <el-button type="primary" @click="addSubFolderOk">确定</el-button>
        </span>
      </el-dialog>-->
    </card>
  </div>
</template>

<script>
import {
  folderTree,
  addSubFolder,
  fileList,
  addFile,
  updateFolder,
  commonFileUpload,
  fileDownload,
  deleteFiles,
  deleteFolders,
  FolderFileNameExist
} from "@/api/templateManagement";
import { importExcelHelper } from "@/utils/excelImportHelper";
import copy from "copy-to-clipboard";
import download from "@/utils/downloadCustom";
import addFolder from "./addFolder";
import editFolder from "./editFolder";
export default {
  mixins: [],
  components: {
    addFolderDialog: addFolder,
    editFolderDialog: editFolder
  },
  props: {},
  data() {
    return {
      rightNode: null, // 右键选中的节点
      multipleSelection: [], // table 勾选中的行
      treeNode: [], // tree数据
      menuVisible: false, // 右键菜单展示
      dialogVisible: false, //
      form: {
        name: "",
        description: ""
      },
      queryModel: "0",
      folderDisabled: false,
      currentNode: null, // 当前选中的节点，左键
      uploading: false, // 正在上传
      defaultProps: {
        children: "children",
        label: "label"
      },
      tableData: [],
      queryParam: {},
      search: "",
      pageNum: 1,
      pageSize: 10,
      total: 0
    };
  },
  computed: {},
  watch: {},
  created() {
    this.reload();
  },
  mounted() {},
  destroyed() {},
  methods: {
    reload() {
      folderTree({}).then(resp => {
        this.treeNode = resp.data;
      });
    },
    /**
     * 切换目录节点
     */
    selectedChange(nodeData) {
      this.menuVisible = false;
      this.currentNode = nodeData;
      this.handleSearch();
    },
    /**
     * 右键
     */
    rightClick(event, object, value, element) {
      //if (this.rightNode === null || this.rightNode.id !== object.id) {
      this.menuVisible = !this.menuVisible;
      this.rightNode = object;
      // } else {
      //   this.menuVisible = !this.menuVisible;
      // }

      if (object.createType == 1) {
        // 系统目录
        this.folderDisabled = true;
      } else {
        this.folderDisabled = false;
      }
      document.addEventListener("click", e => {
        this.menuVisible = false;
      });
      let menu = document.querySelector("#contextMenu");
      /* 菜单定位基于鼠标点击位置 */
      menu.style.left = event.clientX + "px";
      menu.style.top = event.clientY + "px";
      menu.style.position = "absolute"; // 为新创建的DIV指定绝对定位
      //menu.style.width = 160 + "px";
    },
    rightClickContextMenu(index) {
      switch (index) {
        case "1": // 添加子文件夹
          this.$refs.addFolderDialog.show(this.rightNode.id);
          break;
        case "2": // 修改文件夹
          this.$refs.editFolderDialog.show(this.rightNode);
          break;
        case "3": // 删除文件夹
          let curNode = this.$refs.folder.getCurrentNode();

          this.$confirm(
            this.$t("messageCommon.confirmDelete"),
            this.$t("messageCommon.tips"),
            {
              confirmButtonText: this.$t("button.confirm"),
              cancelButtonText: this.$t("button.cancel"),
              type: "warning"
            }
          ).then(() => {
            deleteFolders({ ids: [this.rightNode.id] })
              .then(resp => {
                if (resp.code == 200) {
                  this.$message({
                    message: resp.message,
                    type: "success"
                  });
                  //this.$refs.folder.remove(this.rightNode.id);
                  if (curNode != null && curNode.id == this.rightNode.id) {
                    this.tableData = [];
                  }
                  this.reload();
                }
              })
              .catch(err => {});
          });
          break;
      }
    },

    folderAdded(subFolderObj) {
      //this.rightNode.children.push(subFolderObj);
      this.reload();
    },
    folderEdited(folderObj) {
      // let node = this.$refs.folder.getNode(folderObj.id);
      // this.$refs.folder.updateKeyChildren(node.parentId, [
      //   {
      //     label: folderObj.name,
      //     description: folderObj.description
      //   }
      // ]);
      this.reload();
    },

    allowDrag(node) {
      // 自己创建的节点才可以被拖拽
      return node.data.createType == 2;
    },
    allowDrop(draggingNode, dropNode, type) {
      //return type=="inner"
      return true;
    },
    nodeDrop(dragNode, dropNode, position, event) {
      // 新父节点id
      let newParentId = null;
      if (position != "inner") {
        newParentId = dropNode.data.parentId;
      } else {
        newParentId = dropNode.data.id;
      }

      let param = {
        id: dragNode.data.id,
        parentId: newParentId,
        name: dragNode.data.label,
        description: dragNode.data.description
      };
      updateFolder(param).then(resp => {
        if (resp.code == 200) {
          this.reload();
        }
      });
    },
    handleSearch() {
      if (this.currentNode == null) {
        this.$message({
          message: this.$t("fileLibrary.tip.dirFirst"),
          type: "warning"
        });
        return;
      }

      this.queryParam = {
        containSubFolder: parseInt(this.queryModel),
        folderIds: [this.currentNode.id],
        fileName: this.search,
        pageNum: 1,
        pageSize: this.pageSize
      };

      fileList(this.queryParam).then(resp => {
        //console.log(resp)
        const data = resp.data;
        this.pageNum = data.pageNum;
        this.total = data.total;
        this.tableData = data.list;
      });
    },
    /**
     * 监听分页
     */
    changeTablePage(currentPage, pageSize) {
      // this.pageNum = currentPage
      // this.pageSize = pageSize

      this.queryParam.pageNum = currentPage;
      this.queryParam.pageSize = pageSize;

      fileList(this.queryParam).then(resp => {
        //console.log(resp)
        const data = resp.data;
        this.pageNum = data.pageNum;
        this.total = data.total;
        this.tableData = data.list;
      });
    },

    /**
     * 文件上传
     */
    fileUpload() {
      if (this.currentNode == null) {
        this.$message({
          message: this.$t("fileLibrary.tip.dirFirst"),
          type: "warning"
        });
        return;
      }
      //上传之前要先判断文件名
      importExcelHelper.call(
        this,
        file => {
          FolderFileNameExist({ fileName: file.name }).then(fileNameResp => {
            if (fileNameResp.code === 200) {
              //不存在
              if (fileNameResp.data.nameExist === 0) {
                this.finalUploadFile.call(this, file, 0,fileNameResp.data.folderId);
              }
              //存在且有权查看文件
              if (fileNameResp.data.nameExist === 1) {
                this.$confirm(this.$t('fileLibrary.tip.fileNameExsit')+"<br/><a target='_blank' href='/#/previewfortemplate?id="+
                +fileNameResp.data.id+"' >"+file.name+"</a>", this.$t('messageCommon.tips'), {
                  confirmButtonText: this.$t('button.confirm'),
                  cancelButtonText: this.$t('button.cancel'),
                  type: "warning",
                  dangerouslyUseHTMLString: true
                })
                  .then(() => {
                    this.finalUploadFile.call(this, file, 1,fileNameResp.data.folderId);
                  })
                  .catch(() => {
                  });
              }
              //存在但无权查看文件
              if (fileNameResp.data.nameExist === 2) {
                this.$message.error(this.$t("fileLibrary.tip.fileNameExsitNoAccess"));
              }
            }
          });
          // var postData = new FormData();
          // postData.append("file", file);
          // this.uploading = true;
          // commonFileUpload(postData)
          //   .then(resp => {
          //     if (resp.code === 200) {
          //       const param = {
          //         fileName: resp.data.fileName,
          //         fileSize: resp.data.size,
          //         fileUrl: resp.data.path,
          //         folderId: this.currentNode.id
          //       };

          //       addFile(param)
          //         .then(rsp => {
          //           if (rsp.code === 200) {
          //             this.handleSearch();
          //           }
          //         })
          //         .catch(error => {})
          //         .finally(() => {
          //           this.uploading = false;
          //         });
          //     }
          //   })
          //   .catch(err => {})
          //   .finally(() => {
          //     this.uploading = false;
          //   });
        },
        ".pdf",
        100
      );
    },

    /**
     * 勾选事件
     */
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    /**
     * 删除按钮
     */
    fileDelete() {
      if (this.multipleSelection.length === 0) {
        this.$message({
          message: this.$t("messageCommon.selectAtLeastOne"),
          type: "warning"
        });
        return;
      }

      this.$confirm(
        this.$t("messageCommon.confirmDelete"),
        this.$t("messageCommon.tips"),
        {
          confirmButtonText: this.$t("button.confirm"),
          cancelButtonText: this.$t("button.cancel"),
          type: "warning"
        }
      ).then(() => {
        const ids = this.multipleSelection.map(x => {
          return x.id;
        });
        deleteFiles({ ids: ids })
          .then(resp => {
            if (resp.code == 200) {
              this.$message({
                type: "success",
                message: resp.message
              });
              this.handleSearch();
            }
          })
          .catch(err => {});
      });
    },
    actionHandler(command) {
      switch (command.action) {
        case "copylink":
          copy(command.param.fileShowUrl);
          this.$message({
            message: this.$t("fileLibrary.tip.copy"),
            type: "success"
          });
          break;
        case "download":
          const loading = this.$loading({
            lock: true,
            text: this.$t("checkList.downloading")
          });

          fileDownload(command.param.id).then(resp => {
            loading.close();
            download.downloadByStream(resp, command.param.fileName);
          });
          break;
        case "delete":
          this.$confirm(
            this.$t("messageCommon.confirmDelete"),
            this.$t("messageCommon.tips"),
            {
              confirmButtonText: this.$t("button.confirm"),
              cancelButtonText: this.$t("button.cancel"),
              type: "warning"
            }
          ).then(() => {
            const ids = [command.param.id];
            deleteFiles({ ids: ids })
              .then(resp => {
                if (resp.code == 200) {
                  this.$message({
                    type: "success",
                    message: resp.message
                  });
                  this.handleSearch();
                }
              })
              .catch(err => {});
          });

          break;
      }
    },
    finalUploadFile(file, coverOld,oldFolderId) {
      var postData = new FormData();
      postData.append("file", file);
      this.uploading = true;
      commonFileUpload(postData)
        .then(resp => {
          if (resp.code === 200) {
            const param = {
              fileName: resp.data.fileName,
              fileSize: resp.data.size,
              fileUrl: resp.data.path,
              folderId:coverOld==1?oldFolderId: this.currentNode.id,
              coverOld:coverOld
            };

            addFile(param)
              .then(rsp => {
                if (rsp.code === 200) {
                  this.handleSearch();
                }
              })
              .catch(error => {})
              .finally(() => {
                this.uploading = false;
              });
          }
        })
        .catch(err => {})
        .finally(() => {
          this.uploading = false;
        });
    }
  }
};
</script>
<style lang="scss" scoped>
.libPage {
  width: 100%;
  height: 100%;
  display: flex;

  .lib-tree-wrapper {
    width: 250px;
    min-width: 200px;
    overflow: auto;
  }

  .lib-grid-wrapper {
    margin-left: 10px;
    flex: 1;

    .action-box {
      display: flex;
      margin-bottom: 10px;
      justify-content: space-between;
    }
  }
}

.form-btn-list {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 30px;
}

.menu {
  position: absolute;
  border-radius: 4px;
  // border: 1px solid #999999;
  background-color: #f4f4f4;
  z-index: 999999;
}

.menu-item {
  text-align: center;
}
</style>

<style lang="scss">
.input-with-select .el-input-group__prepend {
  background-color: #fff !important;
}

.el-tree--highlight-current .el-tree-node.is-current > .el-tree-node__content {
  background-color: #b8d9ff;
}
</style>
